import React, {useCallback, useContext, useState} from 'react';
import {AuthContext, CheckRoles, Loader, logout, refreshToken, toast} from "@lb/mlib-components";
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import Divider from "@mui/material/Divider";
import Warehouses from "./Warehouses";
import {jwtDecode} from "jwt-decode";
import {AutoFixHigh, HowToReg} from "@mui/icons-material";

export function handleFixMyProblems() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        try {
            const value = JSON.parse(localStorage.getItem(key));
            if (value && Array.isArray(value.columnOrder) && value.paginationModel) {
                localStorage.removeItem(key);
            }
        } catch {
            // not JSON, so not a persisted grid layout
        }
    }
    window.location.reload()
}

// mlib's Header owns the settings-menu open/anchor state internally and doesn't expose
// a close callback to its settingsActions slot, so these actions can't close the menu
// themselves. Logout/reload naturally unmount or refresh the page regardless.
export default function SettingsActions() {
    const authCtx = useContext(AuthContext);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [accessContent, setAccessContent] = useState([]);

    const logoutHandler = useCallback(() => {
        setOpenBackdrop(true)

        logout(authCtx.accessToken).catch(error => error).finally(() => {
            setOpenBackdrop(false)
            authCtx.clear()
            toast.success('Successfully logged out')
        })

    }, [authCtx])

    const refreshTokens = useCallback(() => {
        setOpenBackdrop(true)

        refreshToken(authCtx.refreshToken).then(async (token) => {
            const accessTokenDecoded = jwtDecode(token.access_token)

            await authCtx.update(
                accessTokenDecoded.name,
                token.access_token,
                accessTokenDecoded.exp,
                token.refresh_token,
                token.refresh_token_exp,
                accessTokenDecoded.azp,
                {
                    realm_access: accessTokenDecoded.realm_access,
                    resource_access: accessTokenDecoded.resource_access
                }
            )

            setAccessContent(authCtx.readRoles())

            setOpenModal(true)
        }).finally(() => setOpenBackdrop(false))
    }, [authCtx])

    return (
        <>
            <Loader active={openBackdrop}/>
            <Warehouses handleChange={() => {
            }}/>
            <Divider/>

            <MenuItem onClick={refreshTokens} disabled={openBackdrop}>
                <ListItemIcon>
                    <HowToReg fontSize="small"/>
                </ListItemIcon>
                Check Roles
            </MenuItem>
            <Divider/>
            <MenuItem onClick={handleFixMyProblems}>
                <ListItemIcon>
                    <AutoFixHigh fontSize="small"/>
                </ListItemIcon>
                Fix My Problems
            </MenuItem>
            <Divider/>
            <MenuItem onClick={logoutHandler} disabled={openBackdrop}>
                <ListItemIcon>
                    <Logout fontSize="small"/>
                </ListItemIcon>
                Logout
            </MenuItem>

            <CheckRoles
                open={openModal}
                onClose={() => setOpenModal(false)}
                roles={accessContent}
            />
        </>
    );
}
